import moment, { Moment } from 'moment';
import Day from './Day';
import { useContext, useMemo } from 'react';
import { DaysContext } from './SingleCalendar';

interface IDaysProps {
  date: Moment;
  today: Moment;
}

const Days = (props: IDaysProps) => {
  const { date, today } = props;
  const { onClick, isDayDisabled } = useContext(DaysContext);

  const base = useMemo(() => moment(date).startOf('month'), [date]);
  const firstDayDate = base.day() === 0 ? 7 : base.day();
  const daysInMonth = moment(date).daysInMonth();

  const prevMonth = moment(date).clone().subtract(1, 'month');
  const prevMonthDays = prevMonth.daysInMonth();
  const nextMonth = moment(date).clone().add(1, 'month');

  const firstLayerBg: JSX.Element[] = [];
  const days: JSX.Element[] = [];
  const labels: JSX.Element[] = [];

  for (let i = 1; i <= 7; i++) {
    labels.push(
      <span key={`lbl-${i}`} className="label">
        {today.clone().day(i).format('ddd')}
      </span>
    );
  }

  for (let i = firstDayDate; i > 1; i--) {
    const d = prevMonth.clone().date(prevMonthDays - i + 2);
    const disabled = isDayDisabled?.(d) ?? false;

    firstLayerBg.push(
      <Day key={`bg-prev-${d.format('YYYY-MM-DD')}`} date={d} disabled />
    );
    days.push(
      <Day
        key={`prev-${d.format('YYYY-MM-DD')}`}
        date={d}
        disabled={disabled}
        onClick={onClick}
        outside
      />
    );
  }

  for (let i = 1; i <= daysInMonth; i++) {
    const d = moment(date).clone().date(i);
    const disabled = isDayDisabled?.(d) ?? false;

    firstLayerBg.push(
      <Day key={`bg-cur-${d.format('YYYY-MM-DD')}`} date={d} disabled />
    );
    days.push(
      <Day
        key={`cur-${d.format('YYYY-MM-DD')}`}
        date={d}
        disabled={disabled}
        onClick={onClick}
      />
    );
  }

  const total = days.length;
  for (let i = 1; i <= 42 - total; i++) {
    const d = nextMonth.clone().date(i);
    const disabled = isDayDisabled?.(d) ?? false;

    firstLayerBg.push(
      <Day key={`bg-next-${d.format('YYYY-MM-DD')}`} date={d} disabled />
    );
    days.push(
      <Day
        key={`next-${d.format('YYYY-MM-DD')}`}
        date={d}
        disabled={disabled}
        onClick={onClick}
        outside
      />
    );
  }

  return (
    <div className="single-calendar-days">
      {labels}
      <div className="single-calendar-days__days">
        <div className="single-calendar-days__bg-layer">{firstLayerBg}</div>
        <div className="single-calendar-days__numbers-layer">{days}</div>
      </div>
    </div>
  );
};

export default Days;
